/** CoStar.Api.SuiteDetail.FundContacts.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["None"] = 0] = "None";
    SortType[SortType["LastNameAsc"] = 1] = "LastNameAsc";
    SortType[SortType["LastNameDesc"] = 2] = "LastNameDesc";
    SortType[SortType["CompanyAsc"] = 3] = "CompanyAsc";
    SortType[SortType["CompanyDesc"] = 4] = "CompanyDesc";
    SortType[SortType["AddressAsc"] = 5] = "AddressAsc";
    SortType[SortType["AddressDesc"] = 6] = "AddressDesc";
    SortType[SortType["TitleAsc"] = 7] = "TitleAsc";
    SortType[SortType["TitleDesc"] = 8] = "TitleDesc";
    SortType[SortType["RolesAsc"] = 9] = "RolesAsc";
    SortType[SortType["RolesDesc"] = 10] = "RolesDesc";
    SortType[SortType["PhoneAsc"] = 11] = "PhoneAsc";
    SortType[SortType["PhoneDesc"] = 12] = "PhoneDesc";
    SortType[SortType["CityAsc"] = 13] = "CityAsc";
    SortType[SortType["CityDesc"] = 14] = "CityDesc";
    SortType[SortType["StateAsc"] = 15] = "StateAsc";
    SortType[SortType["StateDesc"] = 16] = "StateDesc";
    SortType[SortType["CountryAsc"] = 17] = "CountryAsc";
    SortType[SortType["CountryDesc"] = 18] = "CountryDesc";
    SortType[SortType["MarketAsc"] = 19] = "MarketAsc";
    SortType[SortType["MarketDesc"] = 20] = "MarketDesc";
    SortType[SortType["MarketSuffixAsc"] = 21] = "MarketSuffixAsc";
    SortType[SortType["MarketSuffixDesc"] = 22] = "MarketSuffixDesc";
})(SortType || (SortType = {}));
